<template>
  <select v-model="selectedValue" name="select" @change="$emit('change', $event.target.value)">
    <option v-if="placeholder" value="">{{placeholder}}</option>
    <option v-for="option in options" :key="option.value" :value="option.value">
      {{ option.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: "ria-select",
  props: { 
    options: { 
      type: Array, 
      required: true 
    },
    placeholder: {
      type: String, 
      default: null
    },
    selected: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedValue: this.selected ? this.selected : this.placeholder ? "" : this.options[0]
    };
  }
};
</script>

<style lang="scss"></style>
